<template>
  <div>
    <loader :loading="loading"/>

    <page-header :title="$route.params.id ? `Editar Região` : `Nova Região`">
      <template v-slot:breadcrumbs>
        <li>Cidades</li>
        <li v-if="!$route.params.id">Nova Região</li>
        <li v-if="$route.params.id">Regiões</li>
        <li v-if="$route.params.id">Editar Região</li>
      </template>
    </page-header>

    <div class="card bg-white">
      
      <div class="card-body p-4">
        <form>
          <div class="row g-2 pb-4">
          <div class="col-3">
            <div>
                <label class="form-label">Estado</label>
                <select 
                  class="form-select" 
                  v-model="uf"
                  @change="clearFields" 
                  :class="{'is-invalid': $v.uf.$error}"
                >
                  <option value="">Selecione</option>
                  <option v-for="(uf) in states" :value="uf.uf">{{ uf.name }}</option>
                </select>
                <div class="invalid-feedback" v-if="$v.uf.$error">Campo Obrigatório</div>
              </div>
          </div>

          <div class="col-3">
            <div>
                <form-select
                  :invalid="$v.city.$error"
                  :searchable="true"
                  @search="searchCities($event)" 
                  @update="updateCity($event)"
                  :options="citiesLocal"
                  label="Cidade"
                  search-placeholder="Buscar cidade"
                  placeholder="Selecione"
                  :async="true"
                  :has-actions="true"
                  v-model.trim="city"
                  key-name="id"
                  :disabled="!uf"
                > 
                </form-select>
              </div>
          </div>

          <div class="col-3">
            <label class="form-label">Nome da Região</label>
            <input
                type="text"
                class="form-control"
                v-model="name"
                :class="{'is-invalid': $v.name.$error}"
                ref="nameInput"
            />
            <div class="invalid-feedback" v-if="$v.name.$error">Campo Obrigatório</div>
          </div>

          <div class="col-3">
            <div>
                <label class="form-label">Ordem</label>
                <select 
                  class="form-select" 
                  v-model="order"
                  :class="{'is-invalid': $v.order.$error}"
                >
                  <option value="0">Primeiro</option>
                  <option v-if="region.name!==name" v-for="(region) in regions" :value="region.order">Depois de {{ region.name }}</option>
                </select>
                <div class="invalid-feedback" v-if="$v.order.$error">Campo Obrigatório</div>
              </div>
          </div>
        
          <modal id="add-modal" :custom-classes="['modal-dialog-centered', 'modal-lg']" title="Adicionar Bairro" :modal="modal" @close="modal = null">
            <template #body>
              <div class="col-12 pb-4">
                  <form-select
                    ref="neighborhoodInput"
                    :searchable="true"
                    @search="searchNeighborhoods($event)" 
                    @update="updateNeighborhood($event)"   
                    :options="neighborhoodsLocal"
                    label="Bairro"
                    key-name="id"
                    search-placeholder="Buscar bairro"
                    :async="true"
                    :has-actions="true"
                    v-model.trim="neighborhood"
                    :focused="focus"
                  > 
                  </form-select>
              </div> 
            </template>
              <template #footer>
              <div class="d-flex align-items-center justify-content-end">
                <a class="btn btn-primary" @click.prevent="saveNeighborhood">Salvar</a>
              </div> 
              </template>            
          </modal>

        </div>

          <div class="d-flex align-items-center justify-content-between">
            <div>
              <span class="card-subtitle text-primary fw-bold">Bairros da Região</span>
            </div>
            <div class="justify-content-end">  
              <button type="button" class="btn btn-primary btn-sm rounded-pill" @click="openModal">
                <i class="la la-plus"></i>
              </button>
            </div>
          </div>
          <div class="table-responsive mt-3 pb-4">
          
          <table class="table table-striped" v-if="regionNeighborhoods.length">
            <thead>
            <tr>
              <th>Nome do Bairro</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="neighborhood in regionNeighborhoods" :key="neighborhood.id">
              <td>{{ neighborhood.name }}</td>
              <th>
                <div class="d-flex align-items-center justify-content-end">
                  <button type="button" class="btn btn-danger btn-sm" @click="regionNeighborhoods = regionNeighborhoods.filter(item => item.id !== neighborhood.id)">
                    <i class="la la-trash"></i>
                  </button>
                </div>
              </th>
            </tr>
            </tbody>
          </table>
          <div class="bg-light p-2 rounded-2 text-center" v-else>
            <div>Nenhum registro encontrado...</div>
            <div class="invalid-feedback d-block">Adicione no mínimo um bairro.</div>
          </div>
        </div>
        </form>

        <div class="d-flex align-items-center justify-content-end">
          <button class="btn btn-primary" @click="handleSave">Salvar</button>
        </div>  
      </div>
    </div>
  </div>
</template>
<script>
import Loader from "@/components/shared/loader.vue";
import PageHeader from "@/components/PageHeader.vue";
import {mask} from 'vue-the-mask'
import {mapActions, mapState} from "vuex";
import {required, minLength} from "vuelidate/lib/validators";
import FormSelect from "../../components/shared/formSelect.vue";
import {Modal as bsModal} from "bootstrap";
import Modal from "@/components/shared/Modal.vue";
import axios from "axios";

export default {
  name: 'add-region',
  components: {PageHeader, Loader, FormSelect, Modal},
  props: {},
  directives: {mask},
  data() {
    return {
      uf: '',
      city: '',
      selectedCity: null, 
      loading: false,
      name: null,
      neighborhoods: [],
      neighborhoodsLocal: [],
      neighborhood: null,
      selectedNeighborhood: null,
      regionNeighborhoods: [],
      citiesUf: [],
      citiesLocal: [],
      modal: null,
      idCity: null,
      order: '1',
      regions: [],
      focus: true
    }
  },
  validations:{
    name: {required},
    uf: {required},
    city: {required},
    regionNeighborhoods: { 
      required,
      minLength: minLength(1)
    },
    order: {required}
  },
  async mounted() {
    this.modal = bsModal.getOrCreateInstance(document.getElementById('add-modal'));
    const clean = this.$route.query.noRegion; 

    if (this.$route.params.id) {
      this.loading = true;

      const response = await axios.get(`/admin/city-region/${this.$route.params.id}`);
      this.uf = response.data.city.state.uf;
      this.name = clean ? '' : response.data.name;
      this.regionNeighborhoods = clean ? [] : response.data.neighborhoods;
      this.idCity = response.data.city.id;

      this.citiesUf = await this.getCitiesByState(this.uf);
      this.selectedCity = this.citiesUf.find((city) => city.name === response.data.city.name);
      this.city = this.selectedCity.id;
      this.citiesLocal = [];
      this.citiesLocal.push(this.selectedCity);

      if(!clean){
        this.neighborhoods = await this.getNeighborhoods(this.city);
        const params = {
          uf: this.uf,
          city: this.selectedCity.name
        };
        await axios.get(`/admin/city-region/`, {params}).then((response) => {
          this.regions = response.data;
        });
        this.order = clean ? 1 : response.data.order - 1;
      }
      else{
        await this.updateCity(this.selectedCity);
        this.$refs.nameInput.focus();
      }

      this.loading = false;
    }
  },
  computed: {
    ...mapState('Locations', ['states']),
    ...mapState('Regions', ['cities', 'collection']),
  },
  methods: {
    ...mapActions('Regions', ['getCities']),  
    ...mapActions('Locations', ['getCitiesByState', 'getNeighborhoods']),
    searchNeighborhoods(event) {
      if(event){
        event = event.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
        this.neighborhoodsLocal = this.neighborhoods.filter((neighborhood) => {
          return neighborhood.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().includes(event);
        });
      }
      else{
        this.neighborhoodsLocal = [];
      }
    },
    searchCities(event) {
      if(event){
        event = event.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
        this.citiesLocal = this.citiesUf.filter((city) => {
          return city.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().includes(event);
        });
      }
      else{
        this.citiesLocal = [];
      }
    },
    async handleSave() {
      this.$v.$touch();
      if(this.$v.$invalid) {
        return false;
      }

      this.loading = true;
      let data = {
        name: this.name,
        uf: this.uf,
        city: this.selectedCity.name,
        neighborhoods: this.regionNeighborhoods,
        order: this.order + 1
      };

      try {
        if (this.$route.params.id) {
          await axios.put(`/admin/city-region/${this.$route.params.id}`, data);
          window.history.back();
          this.$router.push(`/regioes/${this.idCity}`);
        } else {
          const response = await axios.post(`/admin/city-region`, data);
          this.$router.push(`/regioes/${response.data.city_id}`);
        }
      } catch (error) {
        if (error.response && error.response.status === 409) {
          this.$swal({
            icon: 'error',
            text: 'Esta região já está cadastrada.'
          });
        } else {
          this.$swal({
            icon: 'error',
            text: error
          });
        }
      } finally {
        this.loading = false;
      }
    },
    saveNeighborhood(){
      if(this.selectedNeighborhood){
        const contains = this.regionNeighborhoods.some((neighborhood) => neighborhood.id === this.selectedNeighborhood.id);
        if(!contains) {
          this.regionNeighborhoods.push(this.selectedNeighborhood);
          this.selectedNeighborhood = null;
          this.neighborhood = null;
        }
      }
    },
    openModal() {
      this.$v.$touch();
      if(this.$v.uf.$error || this.$v.city.$error) {
        return false;
      }
      
      this.selectedNeighborhood = null; 
      this.neighborhood = null;
      this.neighborhoodsLocal = [];
      this.modal.show();
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.$refs.neighborhoodInput && this.$refs.neighborhoodInput.showForm) {
            this.$refs.neighborhoodInput.showForm();

            const inputEl = this.$refs.neighborhoodInput.$el.querySelector('input');
            if (inputEl) inputEl.focus();
          }
        }, 500);
      });
    },
    updateNeighborhood(event) {   
      if(event.name){
        this.selectedNeighborhood = event;
        this.neighborhood = event.id;
      }
    },
    async updateCity(event) {
      this.neighborhoodsLocal = [];
      this.regionNeighborhoods = [];
      this.regions = [];

      if(event.name){
        this.loading = true;
        this.selectedCity = event;
        this.neighborhoods = await this.getNeighborhoods(this.city);
        const params = {
          uf: this.uf,
          city: this.selectedCity.name
        };
        await axios.get(`/admin/city-region/`, {params}).then((response) => {
          this.regions = response.data;
          const lastRegion = this.regions.reduce((prev, current) => (prev.order > current.order) ? prev : current, {order: 0});
          this.order = lastRegion.order;
        });
        this.loading = false;
      }
    },
    async clearFields() {
      this.city = '';
      this.regionNeighborhoods = [];
      this.selectedNeighborhood = null;
      this.neighborhoods = [];
      this.neighborhoodsLocal = [];
      this.citiesLocal = [];
      await this.getCitiesByState(this.uf).then((response) => {
        this.citiesUf = response;
      });
    }
  },
}
</script>
<style lang="scss" scoped>

</style>
